import styled from "styled-components";

interface IPanelLayoutSyle {
  centerContent?: boolean;
}

export const Wrapper = styled.div`
  height: 100vh;
  margin: 0;
  display: flex;
  flex-direction: column;
`;
export const Content = styled.div`
  font-size: 2rem;
  width: 100%;
  flex: 2;
  display: flex;

  ${({ centerContent = false }: IPanelLayoutSyle) =>
    centerContent ? `align-self: center; justify-content: center;` : ``};
`;



// WEBPACK FOOTER //
// ./src/components/common/PanelLayout/PanelLayout.style.tsx